import { OrderDisputeStatuses } from 'constants/orderDisputeStatuses';

import { useMemo } from 'react';

import { useGetOne } from 'react-admin';
import { Order } from 'types/embedded/order';
import { OrderDispute } from 'types/embedded/orderDispute';

type Result = {
  hasOpenDispute: boolean;
  lastDispute: OrderDispute | undefined;
};

export function useOrdersDispute(order: Order | undefined): Result {
  const lastDisputeId = useMemo(() => order?.orderDisputes?.at(-1)?.['@id'], [order]);

  const { data: lastDispute } = useGetOne<OrderDispute>('order_disputes', {
    id: lastDisputeId,
  });

  const hasOpenDispute = useMemo(() => {
    if (!lastDisputeId) {
      return false;
    }
    return lastDispute?.disputeStatus === OrderDisputeStatuses.Received;
  }, [lastDispute]);

  return { hasOpenDispute, lastDispute: hasOpenDispute ? lastDispute : undefined };
}
